import React from "react";
import { useFormik } from "formik";
import { Card, Modal } from "react-bootstrap";
import { Checkbox, Input } from "@mobiscroll/react5";
import Loader from "src/components/Dashboard/common/Loader";
import * as Yup from "yup";
import { confirmBankDetails } from "./api";

const BankApprovalPopup = ({ closeApprovalPopup, approvalPopup, clinicId, refetch }) => {
    const [loader, setLoader] = React.useState(false);

    const formik = useFormik({
        initialValues: {
            accountNumberVerified: false,
            ifscVerified: false,
            razorpayAccountId: "",
        },
        validationSchema: Yup.object().shape({
            accountNumberVerified: Yup.boolean().oneOf([true], "Required"),
            ifscVerified: Yup.boolean().oneOf([true], "Required"),
            razorpayAccountId: Yup.string().required("Razorpay ID is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setLoader(true);
            try {
                const payload = {
                    clinicId: clinicId,
                    razorpayAccountId: values.razorpayAccountId,
                };

                await confirmBankDetails(payload);
                resetForm();

                if (refetch) await refetch();
                closeApprovalPopup();
            } catch (error) {
                console.error("Approval failed", error);
            } finally {
                setLoader(false);
            }
        },
    });

    const { values, touched, errors, handleSubmit, handleChange, handleBlur, setFieldValue } = formik;

    return (
        <>
            <Loader show={loader} />
            <Modal
                show={approvalPopup}
                onHide={closeApprovalPopup}
                centered
                backdrop="static"
                size="md"
            >
                <Card className="docg-card docg-patient-form-wrapper">
                    <Card.Header className="customCardHeader">
                        <Card.Title className="mb-0">
                            Approve Bank Details
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <form onSubmit={handleSubmit}>
                            <div className="mbsc-row">
                                <div className="mbsc-col-12 mb-1">
                                    <Checkbox
                                        label="Account Number Verified"
                                        name="accountNumberVerified"
                                        checked={values.accountNumberVerified}
                                        onChange={(e) => setFieldValue("accountNumberVerified", e.target.checked)}
                                    />
                                    {touched.accountNumberVerified && errors.accountNumberVerified &&
                                        <small className="text-danger d-block ml-4">Please verify to continue</small>}
                                </div>

                                <div className="mbsc-col-12 mb-1">
                                    <Checkbox
                                        label="IFSC Code Verified"
                                        name="ifscVerified"
                                        checked={values.ifscVerified}
                                        onChange={(e) => setFieldValue("ifscVerified", e.target.checked)}
                                    />
                                    {touched.ifscVerified && errors.ifscVerified &&
                                        <small className="text-danger d-block ml-4">Please verify to continue</small>}
                                </div>

                                <div className="mbsc-col-12 my-3">
                                    <Input
                                        label="RazorPay Account ID"
                                        name="razorpayAccountId"
                                        type="text"
                                        inputStyle="underline"
                                        labelStyle="floating"
                                        value={values.razorpayAccountId}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.razorpayAccountId && !!errors.razorpayAccountId}
                                        errorMessage={errors.razorpayAccountId}
                                    />
                                </div>

                                <div className="mbsc-col-12 mt-4 d-flex justify-content-end">
                                    <button
                                        type="button"
                                        onClick={closeApprovalPopup}
                                        className="docg-outline-btn mr-3"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="docg-save-btn"
                                        disabled={!values.accountNumberVerified || !values.ifscVerified}
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Card.Body>
                </Card>
            </Modal>
        </>
    );
};

export default BankApprovalPopup;